export default "__VITE_ASSET__8ffINKXh__"